// Class to manage session storage
class SessionStorageManager {
  // Constructor to initialize the class
  constructor() {
    this.storage = window.sessionStorage;
  }

  // Method to set an item in session storage
  setItem(key, value) {
    this.storage.setItem(key, JSON.stringify(value));
  }

  // Method to get an item from session storage
  getItem(key) {
    const item = this.storage.getItem(key);
    if (item) {
      return JSON.parse(item);
    }
    return null;
  }

  // Method to remove an item from session storage
  removeItem(key) {
    this.storage.removeItem(key);
  }

  // Method to clear all items in session storage
  clear() {
    this.storage.clear();
  }
}

export default new SessionStorageManager();